import '../../styles/workflows.css';
export function modal(title) {
  const dialog = document.createElement('dialog');
  dialog.className = 'resume-workflow';
  const heading = document.createElement('h2'); heading.textContent = title;
  const close = document.createElement('button'); close.textContent = 'Close'; close.className = 'race-form-btn';
  close.addEventListener('click', () => dialog.close());
  dialog.append(heading, close);
  dialog.addEventListener('close', () => dialog.remove());
  document.body.append(dialog); dialog.showModal();
  return dialog;
}
export function button(label, action) {
  const el = document.createElement('button'); el.type = 'button'; el.className = 'race-form-btn'; el.textContent = label;
  el.addEventListener('click', action); return el;
}
